

import { Box, Paper, Typography, Button } from '@mui/material';
import { CheckCircleOutline } from '@mui/icons-material';
import { Link } from 'react-router-dom';

/**
 * Componente de página estática (pública) para exibir uma mensagem de sucesso
 * após o candidato enviar sua candidatura inicial.
 * @returns {JSX.Element}
 */
export default function ApplicationSuccess() {
  return (
    <Box 
      sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        minHeight: '80vh',
        p: 2 
      }}
    >
      <Paper 
        sx={{ 
          p: { xs: 3, md: 5 }, 
          maxWidth: 500, 
          textAlign: 'center' 
        }}
      >
        <CheckCircleOutline color="success" sx={{ fontSize: 60, mb: 2 }} />
        
        <Typography variant="h4" gutterBottom>
          Candidatura Enviada!
        </Typography>
        
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          Recebemos suas informações com sucesso. Agradecemos pelo seu interesse!
          Entraremos em contato em breve caso seu perfil seja compatível com a vaga.
        </Typography>
        
        <Button 
          component={Link} 
          to="/" 
          variant="outlined"
        >
          Voltar ao Início
        </Button>
      </Paper>
    </Box>
  );
}